import { render, staticRenderFns } from "./feedbacks-table.vue?vue&type=template&id=48a9b034&scoped=true"
import script from "./feedbacks-table.vue?vue&type=script&lang=js"
export * from "./feedbacks-table.vue?vue&type=script&lang=js"
import style0 from "./feedbacks-table.vue?vue&type=style&index=0&id=48a9b034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a9b034",
  null
  
)

export default component.exports